<template>
  <div
    class="precipitation-calculator"
  >
    <h4>Precipitation Calculator</h4>
    <div
      class="edit-grid"
    >
      <div class="grid__title">
        <h5>Average Emitter Flow Rate</h5>
      </div>
      <div>
        <input
          v-model="averageEmitterFlowRate"
          type="text"
          pattern= "^\d*\.?\d+$"
        >
        {{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}
      </div>

      <div class="grid__title">
        <h5>Row Spacing</h5>
      </div>
      <div>
        <input
          v-model="rowSpacing"
          type="text"
          pattern= "^\d*\.?\d+$"
        >
        {{ getDenominator('centimetre', 'foot', 0) }}
      </div>

      <div class="grid__title">
        <h5>Emitter Spacing</h5>
      </div>
      <div>
        <input
          v-model="emitterSpacing"
          type="text"
          pattern= "^\d*\.?\d+$"
        >
        {{ getDenominator('centimetre', 'inch', 0) }}
      </div>

      <div class="grid__title">
        <h5>Precipitation rate</h5>
      </div>
      <div>
        <input
          :value="computedPrecipitationRate.toFixed(2)"
          disabled
          type="text"
          pattern= "^\d*\.?\d+$"
          min="0"
        >
        {{ getDenominator('centimetre', 'inch', 0) + '/' + $tc('messages.sharedTexts.time.h', 1) }}
      </div>
    </div>
    <div class="copy">
      <button
        class="g-btn g-btn--blue g-btn--rounded"
        :disabled="computedPrecipitationRate === 0"
        @click.stop="transferValue"
      >
        Transfer Value
      </button>
    </div>
  </div>
</template>

<script>
import {UnitSystem} from '@/assets/javascript/mixins/Mixins'

export default {
  name: 'PrecipitationCalculatorElement',
  mixins: [UnitSystem],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      averageEmitterFlowRate: 0,
      rowSpacing: 0,
      emitterSpacing: 0,
    }
  },
  computed: {
    computedPrecipitationRate() {
      const waterPerHour = parseFloat(this.averageEmitterFlowRate, 10)
      const rs = parseFloat(this.rowSpacing, 10)
      const es = parseFloat(this.emitterSpacing, 10)

      return waterPerHour && rs && es
      ? (231.1 * waterPerHour / (rs * es))
      : 0
    }
  },
  methods: {
    transferValue() {
      console.log('click')
      this.$emit('transfer-precip', this.convertUnits(this.computedPrecipitationRate, 'cm', 'in'))
    }
  }
}
</script>

<style lang="scss">
  .precipitation-calculator {
    h4 {
      margin-top: 10px;
    }
  }
</style>